import { render } from "./ProjectDetails.vue?vue&type=template&id=1724ada2&ts=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__